module.exports = __webpack_public_path__ + "9cf14160b6437ad14967f647f2e7c97f.svg";